// extracted by mini-css-extract-plugin
module.exports = {"link-label":"styles_link-label__OZLQc","arrow-icon":"styles_arrow-icon__F_dkK","children-container":"styles_children-container__0FSmC"};